
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App/layout/App';
import ScrollToTop from './App/layout/ScrollToTop';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-widgets/dist/css/react-widgets.css';
import dateFnsLocalizer from 'react-widgets-date-fns';
import {MsalProvider} from "@azure/msal-react";
import msalContext from "./App/api/msalAuth";
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import {msalConfig} from "./msalConfig";
//my new article in shining armor:
//msal startup: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
//example app: https://github.com/Azure-Samples/ms-identity-javascript-react-tutorial/blob/main/6-AdvancedScenarios/1-call-api-obo/README.md
//how to migrate: https://learn.microsoft.com/en-us/entra/msal/dotnet/how-to/msal-net-migration
//authentication via OBO,
dateFnsLocalizer();
// export const msalContext = new PublicClientApplication(msalConfig);

export const history = createBrowserHistory();

// Default to using the first account if no account is active on page load
if (!msalContext.getActiveAccount() && msalContext.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    // @ts-ignore
    msalContext.setActiveAccount(msalContext.getActiveAccount()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalContext.enableAccountStorageEvents();

// Listen for sign-in event and set active account
msalContext.addEventCallback((event) => {
    // @ts-ignore
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        // @ts-ignore
        const account = event.payload.account;
        msalContext.setActiveAccount(account);
    }
});

ReactDOM.render(
    <MsalProvider instance={msalContext}>
        <Router history={history}>
            <ScrollToTop>
                <App />
            </ScrollToTop>
        </Router>
    </MsalProvider>
    , document.getElementById("root"));
